import {
  FETCH_QUESTION_PENDING,
  FETCH_QUESTION_REJECTED,
  FETCH_QUESTION_FULFILLED,
  CLEAR_FETCH_QUESTION,
} from 'constants/itemQuestions';

const initialState = {
  pending: true,
  brand: {},
  error: {},
  success: false,
};

export const itemQuestions = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUESTION_FULFILLED:
      return {
        ...state,
        itemQuestions: action.response,
        pending: false,
        success: true,
      };

    case FETCH_QUESTION_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_QUESTION_PENDING:
      return {
        ...state,
        error: {},
      };

    case CLEAR_FETCH_QUESTION:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/itemQuestions.js